import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import idx from 'idx';
import { requestAccess } from 'project/ducks/ndas';
import { toggleParticipateForm } from 'project/ducks/form';
import {
  canRequestProjectAccess, canWatch, canExtendDeadline,
  getProjectIdFromUrl, canUpgrade, canDownloadInvoice, canAddAwards,
  canShare, canReportProjectViolation, getParticipationForbiddenReason,
  canReserveElite, canRequestEarlyClose
} from 'project/utils';
import { shareLink } from 'common/utils';
import ActionsMenu from 'project/components/header_actions_menu';
import { toggleViolationModal, getInvoice } from 'project/ducks/project';
import { toggleAwardsModal } from 'project/ducks/awards';
import { toggleFeaturesModal, toggleExtendModal } from 'project/ducks/features';

const mapStateToProps = (state, { params }) => ({
  canRequestAccess: canRequestProjectAccess(state),
  canParticipate: !getParticipationForbiddenReason(state),
  canWatch: canWatch(state),
  canExtend: canExtendDeadline(state),
  canUpgrade: canUpgrade(state),
  canDownloadInvoice: canDownloadInvoice(state),
  canAddAwards: canAddAwards(state),
  canShare: canShare(state),
  canReportProjectViolation: canReportProjectViolation(state),
  canReserveElite: canReserveElite(state),
  canRequestEarlyClose: canRequestEarlyClose(state),
  projectId: getProjectIdFromUrl(params),
  invoicePdf: idx(getInvoice(state), _ => _.pdf)
});

const mapDispatchToProps = (dispatch, { params }) => {
  const actions = bindActionCreators({
    toggleAwardsModal,
    toggleFeaturesModal,
    toggleExtendModal,
    requestAccess,
    toggleParticipateForm,
    toggleViolationModal: partial(toggleViolationModal, {
      type: 'project',
      id: getProjectIdFromUrl(params)
    })
  }, dispatch);

  /* @TODO: grab shortened URL for this project */
  const link = typeof window !== 'undefined'
    ? `${window.location.origin}/${params.subcategory}/${params.pageSlug}`
    : '';

  return {
    ...actions,
    share: partial(shareLink, link),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActionsMenu));
